var USERS = 'USERS';
var USERTOTAL = 'USERTOTAL';
var CURRENT_USER = 'CURRENT_USER';
var UX_PROFILE = 'UX_PROFILE';
var MY_UX_PROFILE = 'MY_UX_PROFILE';
var MY_ACTIVITY_STATUS = 'MY_ACTIVITY_STATUS';
export { USERS, USERTOTAL, CURRENT_USER, UX_PROFILE, MY_UX_PROFILE, MY_ACTIVITY_STATUS };